// src/components/LogoCircuit.jsx
export default function LogoCircuit({ className = "h-8 w-auto", dark = "#0F172A", accent = "#22C55E" }) {
  return (
    <svg className={className} viewBox="0 0 280 40" xmlns="http://www.w3.org/2000/svg" aria-label="AndreiTech">
      {/* Circuit A */}
      <g fill="none" stroke={accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 30 28 10 38 30" />
        <path d="M22.5 22h11" />
        <circle cx="22.5" cy="22" r="2" fill={accent} />
        <circle cx="33.5" cy="22" r="2" fill={accent} />
      </g>
      {/* Wordmark */}
      <text x="54" y="27" fontFamily="Inter, ui-sans-serif, system-ui" fontSize="20" fontWeight="800" fill={dark}>
        Andrei
      </text>
      <text x="122" y="27" fontFamily="Inter, ui-sans-serif, system-ui" fontSize="20" fontWeight="800" fill={accent}>
        Tech
      </text>
    </svg>
  );
}
